import { AccordionDetails as Mui4AccordionDetails } from '@material-ui/core'
import {
  AccordionDetailsProps as Mui5AccordionDetailsProps,
  default as Mui5AccordionDetails,
} from '@mui/material/AccordionDetails'
import { forwardRef } from 'react'
import { useComponentVersion } from '../../hooks/useComponentVersion'
import { OsAccordionVersion } from './Accordion'

export type AccordionDetailsProps = Mui5AccordionDetailsProps

export const AccordionDetails = forwardRef<HTMLDivElement, AccordionDetailsProps>((props, ref) => {
  const version = useComponentVersion('accordion')

  switch (version) {
    case OsAccordionVersion.V2:
      return <Mui5AccordionDetails {...props} ref={ref} />
    default:
      return <Mui4AccordionDetails {...props} ref={ref} />
  }
})
